import { createSlice } from "@reduxjs/toolkit"

interface MetricsStateType {
  selectedMetricsTab: any
}

const initialState: MetricsStateType = {
  selectedMetricsTab: 0,
}

const metricsSlice = createSlice({
  name: "metrics",
  initialState,
  reducers: {
    setSelectedMetricsTab: (state, action) => {
      state.selectedMetricsTab = action.payload
    },
  },
})

export default metricsSlice.reducer
export const { setSelectedMetricsTab } = metricsSlice.actions
